import React, {useState, useRef} from 'react';
import Icon from '../Icons/Icon';
import { useSearch } from './index';
import Modal from '../Modal';
import { classNames } from '../../Services/helpers';
import Loading from '../Loading';
import Dropdown from '../Dropdown';
import SavedSearches from './SavedSearches';

const SearchBar = ({filterForm, modalOptions, isLoading, sideMenu, searchCategory}) => {
    const {setSearchField, searchData, setSearchData, hasSearchConditions} = useSearch();
    const [filterModalOpen, setFilterModalOpen] = useState(false);
    const inputRef = useRef(null);

    return <>
        <div className="flex flex-row w-full gap-x-">

            <div className="flex items-center border rounded-full focus-within:ring-2 focus-within:ring-brand mx-1 pr-2 grow">
                <input ref={inputRef}
                    type="text"
                    placeholder="Search..."
                    className="grow px-3 py-2 border-none rounded-full text-gray-900 placeholder:text-gray-400 focus:ring-0 text-sm sm:leading-6"
                    value={searchData?.search ?? ''}
                    onChange={(e) => setSearchField('search', e.target.value)}
                />

                {isLoading && <Loading inline />}

                <button
                    onClick={() => {
                        setSearchData({});
                        inputRef.current.focus();
                    }}
                    className={classNames(
                        'mx-1 p-2 rounded-full border bg-gray-100 flex flex-none items-center justify-center focus:outline-none focus:background-none fill-muted',
                        hasSearchConditions || 'hidden'
                    )}
                >
                    <Icon icon="XMark" size="0.5x" inline />
                </button>

                {filterForm && <button
                    onClick={() => setFilterModalOpen(!filterModalOpen)}
                    className={classNames(
                        'mx-1 mr-2 ml-3 p-2 rounded-full flex flex-none items-center justify-center',
                        // 'px-3 py-2 bg-grey-300  border-none rounded-full focus:outline-none mr-2',
                        // hasSearchConditions ? 'bg-brand fill-white hover:fill-brand-light focus:fill-brand-light' : 'fill-gray-300 hover:fill-brand focus:fill-brand',
                        hasSearchConditions ?
                            'fill-brand border border-brand hover:fill-brand-light focus:fill-brand-light rounded-full bg-slate-100' :
                            'fill-muted hover:fill-brand focus:fill-brand'
                    )}
                >
                    <Icon icon="Filter"
                        size={hasSearchConditions ? '0.5x' : '1x'}
                        theme="solid"
                        inline
                    />
                </button>}
            </div>


            {sideMenu && <div className="shrink-0">
                <Dropdown options={sideMenu} />
            </div>}
        </div>

        {searchCategory && <SavedSearches {...{searchCategory}} />}

        {filterForm && <Modal isOpen={filterModalOpen}
                        setIsOpen={setFilterModalOpen}
                        {...modalOptions}
                        dismissible
                    >
            {filterForm}
        </Modal>}
    </>
}

export default SearchBar;
